/**
 * Runtime Context
 * ----------------
 * Autorité unique pour le temps et l'aléa.
 *
 * ⚠️ RÈGLE ABSOLUE
 * Il est INTERDIT d'appeler Date.now() ou Math.random()
 * dans tout chemin critique (analyse, scoring, intégrité).
 *
 * Toute source de variabilité DOIT passer par ce contexte.
 */

export interface RuntimeContext {
  now(): number;
  uuid(): string;
}

let runtimeContext: RuntimeContext = {
  now: () => Date.now(),
  uuid: () => {
    if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
      return crypto.randomUUID();
    }
    // Fallback strictement cantonné ici
    return Math.random().toString(36).slice(2);
  }
};

/**
 * Injection explicite (tests, audit, replay).
 */
export function setRuntimeContext(ctx: RuntimeContext) {
  runtimeContext = ctx;
}

/**
 * Accès global contrôlé.
 */
export function getRuntimeContext(): RuntimeContext {
  return runtimeContext;
}
